import { call, put, select } from 'redux-saga/effects';
import SignupActions from '../actions/SignupActions';
import ActivationActions from '../actions/ActivationActions';
import ChangePasswordActions from '../actions/ChangePasswordActions';
import ResetPasswordActions from '../actions/ResetPasswordActions';
import { getEmail, getPassword } from '../reducers/SignupReducer';
import { getErrorMessage } from '../../services/Errors';
import {
  getCurrentPassword,
  getNewPassword,
} from '../reducers/ChangePasswordReducer';

const { signupSuccess, signupFailure } = SignupActions;

export function* signup(api, { history }) {
  const email = yield select(getEmail);
  const password = yield select(getPassword);
  const response = yield call(api.register, email, password);
  if (response.ok) {
    yield put(signupSuccess());
    yield call(history.push, '/signup-confirmed');
  } else {
    yield put(signupFailure(getErrorMessage(response, 'Unable to register.')));
  }
}

const { activationSuccess, activationFailure } = ActivationActions;

export function* activateAccount(api, { key, history }) {
  const response = yield call(api.activateAccount, key);
  if (response.ok) {
    yield put(activationSuccess());
    yield call(history.push, '/login');
  } else {
    yield put(
      activationFailure(getErrorMessage(response, 'Unable to activate.'))
    );
  }
}

const { changePasswordSuccess, changePasswordFailure } = ChangePasswordActions;

export function* changePassword(api) {
  const currentPassword = yield select(getCurrentPassword);
  const newPassword = yield select(getNewPassword);
  const response = yield call(api.changePassword, currentPassword, newPassword);
  if (response.ok) {
    yield put(changePasswordSuccess());
    // yield call(history.push, '/login');
  } else {
    yield put(
      changePasswordFailure(getErrorMessage(response, 'Unable to activate.'))
    );
  }
}

const {
  initResetPasswordSuccess,
  initResetPasswordFailure,
  finishResetPasswordSuccess,
  finishResetPasswordFailure,
} = ResetPasswordActions;

export function* initResetPassword(api, { email }) {
  const response = yield call(api.initPasswordReset, email);
  if (response.ok) {
    yield put(initResetPasswordSuccess());
  } else {
    if (response.data) {
      yield put(
        initResetPasswordFailure(
          getErrorMessage(
            response,
            'Unable to initiate password reset process.'
          ),
          response.data.code
        )
      );
    } else {
      yield put(
        initResetPasswordFailure(
          getErrorMessage(
            response,
            'Unable to initiate password reset process.'
          ),
          null
        )
      );
    }
  }
}

export function* finishResetPassword(api, { key, password }) {
  const response = yield call(api.finishPasswordReset, key, password);
  if (response.ok) {
    yield put(finishResetPasswordSuccess());
  } else {
    yield put(
      finishResetPasswordFailure(
        getErrorMessage(response, 'Unable to change password.')
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/state/sagas/AccountSagas.js